(function(){
  var cleaned = false;
  function cleanToolbar(){
    var all = document.querySelectorAll('.hdt-control-layout, hdt-view-layout-switch');
    if (all.length){
      var allHidden = true;
      all.forEach(function(el){
        if (el.getAttribute('aria-hidden') !== 'true') allHidden = false;
      });
      if (!allHidden){
        all.forEach(function(el){
          if (el.getAttribute('aria-hidden') === 'true') return;
          el.style.setProperty('display','none','important');
          el.style.setProperty('visibility','hidden','important');
          el.style.setProperty('width','0','important');
          el.style.setProperty('max-width','0','important');
          el.style.setProperty('height','0','important');
          el.style.setProperty('overflow','hidden','important');
          el.style.setProperty('flex','0 0 0','important');
          el.setAttribute('aria-hidden','true');
        });
      }
    }
    document.querySelectorAll('.hdt-control-filter').forEach(function(el){
      if (el.dataset.aydinsCleaned) return;
      el.style.setProperty('flex','1 1 50%','important');
      el.style.setProperty('max-width','50%','important');
      el.dataset.aydinsCleaned = '1';
    });
    document.querySelectorAll('.hdt-control-sort').forEach(function(el){
      if (el.dataset.aydinsCleaned) return;
      el.style.setProperty('flex','1 1 50%','important');
      el.style.setProperty('max-width','50%','important');
      el.style.setProperty('margin-left','auto','important');
      el.style.setProperty('justify-content','flex-end','important');
      el.style.setProperty('text-align','right','important');
      el.dataset.aydinsCleaned = '1';
    });
  }
  cleanToolbar();
  document.addEventListener('DOMContentLoaded', cleanToolbar);
  window.addEventListener('load', cleanToolbar);
  setTimeout(cleanToolbar, 300);
  setTimeout(cleanToolbar, 1000);
  setTimeout(cleanToolbar, 2500);
  var target = document.querySelector('main, body') || document.documentElement;
  var obs = new MutationObserver(cleanToolbar);
  obs.observe(target, {childList:true, subtree:true});
  setTimeout(function(){ obs.disconnect(); }, 10000);
})();

(function(){
  var applied = false;
  var obs;
  function applyServiceStripeIntro(){
    if (applied) return;
    if (!/\/collections\/service-stripe-rings/.test(location.pathname)) return;
    if (document.querySelector('.v4e-collection-intro')) { applied = true; if (obs && obs.disconnect) obs.disconnect(); return; }
    var html = '<div class="v4e-collection-intro"><h2>Service Stripe Men’s Wedding Bands</h2><p>Shop Aydins rings with bold blue and red stripe details: titanium, ceramic, and tungsten styles built for daily wear, clean contrast, and personal engraving.</p><p><strong>Free Engraving \xB7 Lifetime Warranty \xB7 Lifetime Sizing \xB7 Free U.S. Shipping</strong></p></div>';
    var targets = [].slice.call(document.querySelectorAll('.hdt-collection-description .hdt-rte, .hdt-main-collection-description-wrap .hdt-rte, .collection__description, .collection-hero__description'));
    var hit = false;
    targets.forEach(function(el){
      if (!el) return;
      if (el.querySelector('.v4e-collection-intro')) { hit = true; return; }
      if (/Service Stripe|blue and red|titanium|ceramic|tungsten/i.test(el.textContent || '')){
        el.innerHTML = html;
        hit = true;
      }
    });
    if (hit){
      applied = true;
      if (obs && obs.disconnect) obs.disconnect();
    }
  }
  applyServiceStripeIntro();
  document.addEventListener('DOMContentLoaded', applyServiceStripeIntro);
  window.addEventListener('load', applyServiceStripeIntro);
  setTimeout(applyServiceStripeIntro, 300);
  setTimeout(applyServiceStripeIntro, 1000);
  setTimeout(applyServiceStripeIntro, 2500);
  var target = document.querySelector('main, body') || document.documentElement;
  obs = new MutationObserver(applyServiceStripeIntro);
  obs.observe(target, {childList:true, subtree:true});
  // Hard safety: disconnect after 10s no matter what
  setTimeout(function(){ if (obs && obs.disconnect) obs.disconnect(); }, 10000);
})();
